export const getHomeListPrice = (rentAmount) =>
  rentAmount < 1000 ? `$${rentAmount}` : `$${(rentAmount / 1000).toFixed(1)}k`;
